import {KnowledgeObject} from "../../../domain/entities/knowledge-object.entity";

/**
 * Injected collaborators of the delete flow. Keeping confirm + dispatch as
 * dependencies makes the confirm-gate unit-testable — the component itself
 * cannot be exercised under `environment: 'node'` (no DOM).
 */
export interface KnowledgeObjectDeleteDeps {
    /** Asks the user for confirmation; resolves false on cancel/dismiss. */
    confirm: (knowledgeObject: KnowledgeObject) => Promise<boolean>;
    /** Dispatches the delete command for the given entity. */
    dispatch: (knowledgeObject: KnowledgeObject) => Promise<void>;
}

/**
 * Confirm-then-delete flow for a KnowledgeObject row action.
 *
 * Returns true only when the deletion was actually dispatched. A rejected
 * dispatch propagates so the caller can surface it instead of silently
 * removing the row from the UI.
 */
export async function deleteKnowledgeObject(
    knowledgeObject: KnowledgeObject | null,
    deps: KnowledgeObjectDeleteDeps
): Promise<boolean> {
    if (!knowledgeObject) {
        return false;
    }

    const confirmed = await deps.confirm(knowledgeObject);
    if (!confirmed) {
        return false;
    }

    await deps.dispatch(knowledgeObject);
    return true;
}
